// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3DQcx","noInteraction":"EventWrapper_noInteraction__x21DI"};